interface InjectScript {
  src: string
  onload?: () => void
}

export const injectScript = ({ src, onload }: InjectScript) => {
  const alreadyInjected = document.querySelector(`script[src="${src}"]`)
  if (alreadyInjected) {
    if (onload) {
      onload()
    }
    return
  }

  const script = document.createElement('script')
  script.src = src
  script.async = true

  if (onload) {
    script.onload = onload
  }

  document.body.appendChild(script)
}
